import React, {useCallback, useEffect, useState} from 'react';

import {ComposedChart, Brush, LineChart, Tooltip, Line, CartesianGrid, XAxis, YAxis, Bar} from 'recharts';
import {formatDate, formatShortDate} from "../../config";
import moment from "moment";

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function ProfitGraphChart(props) {
    const classPrefix = props.classPrefix
    const items = props.items
    const translate = props.translate
    const getProfitDone = props.getProfitDone

    const colorProfitUSDT = '#ff462f';
    const colorProfitPercent = '#39ef39';
    const colorCountCycles = '#fff';
    const colorAmount = '#8da5ef';

    const [showProfitUSDT, setProfitUSDT] = useState(true);
    const [showProfitPercent, setProfitPercent] = useState(false);
    const [showCountCycles, setCountCycles] = useState(false);
    const [showAmount, setAmount] = useState(false);
    const [chartMode, setChartMode] = useState('day');


    const toggleProfitUSDT = () => {
        setProfitUSDT((prevState) => !prevState);
    };
    const toggleProfitPercent = () => {
        setProfitPercent(prevState => !prevState);
    };
    const toggleCountCycles = () => {
        setCountCycles(prevState => !prevState);
    };
    const toggleAmount = () => {
        setAmount(prevState => !prevState);
    };
    const setDayChartMode = () => {
        setChartMode('day');
    };
    const setMonthChartMode = () => {
        setChartMode('month');
    };

    const renderLabelProfitUSDT = (props) => renderLabel(props, colorProfitUSDT)
    const renderLabelProfitPercent = (props) => renderLabel(props, colorProfitPercent)
    const renderLabelCountCycles = (props) => renderLabel(props, colorCountCycles)
    const renderLabelAmountDaily = (props) => renderLabel(props, colorAmount)


    let dailyData = []
    let monthlyData = []

    function setMax(item) {
        const compareArray = []

        if (showProfitUSDT) {
            compareArray.push(+item.CycleProfitDONE)
        }
        if (showProfitPercent) {
            compareArray.push(+item.CycleProfitDONE)
        }
        if (showCountCycles) {
            compareArray.push(+item.CycleProfitDONECnt)
        }

        return compareArray.length > 0 ? Math.max(...compareArray) : 0;
    }

    if (items.daily) {
        items.daily.forEach((dailyItem) => {
            const date = formatShortDate(new Date(+dailyItem.period_from * 1000))

            dailyData.push({
                name: date,
                max: setMax(dailyItem),
                profitUSDT: +dailyItem.CycleProfitDONE,
                profitPercent: +dailyItem.CycleProfitDONEPrc,
                countCycles: +dailyItem.CycleProfitDONECnt,
                amountDaily: +dailyItem.AmountForOperDONE,
            })
        });
    }

    if (items.monthly) {
        items.monthly.forEach((monthlyItem) => {
            const date = capitalizeFirstLetter(moment(new Date(+monthlyItem.period_from * 1000)).locale(window.locale).format('MMMM YY'))

            monthlyData.push({
                name: date,
                max: setMax(monthlyItem),
                profitUSDT: +monthlyItem.CycleProfitDONE,
                profitPercent: +monthlyItem.CycleProfitDONEPrc,
                countCycles: +monthlyItem.CycleProfitDONECnt,
                amountDaily: +monthlyItem.AmountForOperDONE,
            })
        });
    }

    const profitUSDTDailyChart
        = showProfitUSDT && chartMode === 'day'
        ? <Line
            yAxisId={'left'}
            isAnimationActive={false}
            type="monotone"
            dataKey="profitUSDT"
            strokeWidth={2}
            stroke={colorProfitUSDT}
            dot={renderDot}
            label={renderLabelProfitUSDT}

        />
        : null

    const profitPercentDailyChart
        = showProfitPercent && chartMode === 'day'
        ? <Line
            yAxisId={'left'}
            isAnimationActive={false}
            type="monotone"
            dataKey="profitPercent"
            strokeWidth={2}
            stroke={colorProfitPercent}
            dot={renderDot}
            label={renderLabelProfitPercent}

        />
        : null

    const countCyclesDailyChart
        = showCountCycles && chartMode === 'day'
        ? <Line
            yAxisId={'left'}
            isAnimationActive={false}
            type="monotone"
            dataKey="countCycles"
            strokeWidth={2}
            stroke={colorCountCycles}
            dot={renderDot}
            label={renderLabelCountCycles}

        />
        : null

    const amountDailyChart
        = showAmount && chartMode === 'day'
        ? <Bar
            yAxisId={'right'}
            isAnimationActive={false}
            dataKey="amountDaily"
            fill={colorAmount}
            label={renderLabelAmountDaily}

        />
        : null


    const dailyBrush
        = chartMode === 'day' && dailyData.length > 31
        ? <Brush
            dataKey="name"
            height={30}
            stroke="#fff"
            fill={'rgba(49,45,95,.9)'}
            startIndex={dailyData.length - 32}
            endIndex={dailyData.length - 1}
        />
        : null

    const monthlyBrush
        = chartMode === 'month' && monthlyData.length > 12
        ? <Brush
            dataKey="name"
            height={30}
            stroke="#fff"
            fill={'rgba(49,45,95,.9)'}
            startIndex={monthlyData.length - 12}
            endIndex={monthlyData.length - 1}

        />
        : null

    const profitUSDTMonthlyChart
        = showProfitUSDT && chartMode === 'month'
        ? <Line
            yAxisId={'left'}
            isAnimationActive={false}
            type="monotone"
            dataKey="profitUSDT"
            strokeWidth={2}
            stroke={colorProfitUSDT}
            dot={renderDot}
            label={renderLabelProfitUSDT}

        />
        : null

    const profitPercentMonthlyChart
        = showProfitPercent && chartMode === 'month'
        ? <Line
            yAxisId={'left'}
            isAnimationActive={false}
            type="monotone"
            dataKey="profitPercent"
            strokeWidth={2}
            stroke={colorProfitPercent}
            dot={renderDot}
            label={renderLabelProfitPercent}

        />
        : null

    const countCyclesMonthlyChart
        = showCountCycles && chartMode === 'month'
        ? <Line
            yAxisId={'left'}
            isAnimationActive={false}
            type="monotone"
            dataKey="countCycles"
            strokeWidth={2}
            stroke={colorCountCycles}
            dot={renderDot}
            label={renderLabelCountCycles}

        />
        : null

    const amountMonthlyChart
        = showAmount && chartMode === 'month'
        ? <Bar
            yAxisId={'right'}
            isAnimationActive={false}
            dataKey="amountDaily"
            fill={colorAmount}
            label={renderLabelAmountDaily}

        />
        : null


    const chartData = chartMode === 'day' ? dailyData : monthlyData

    return <div className={`${classPrefix}__chart`}>

        <div className={`${classPrefix}__chart-header`}>

            <div className={`${classPrefix}__chart-header-item`}>
                <div
                    className={`${classPrefix}__chart-header-item-selector
                        ${showProfitUSDT ? classPrefix + '__chart-header-item-selector--active' : ''}`}

                    onClick={toggleProfitUSDT}
                >
                    <div style={{backgroundColor: colorProfitUSDT}}
                         className={`${classPrefix}__chart-header-item-selector-icon ${classPrefix}__chart-header-item-selector-icon--line`}></div>
                    <div className={`${classPrefix}__chart-header-item-selector-name`}>{translate['profitUSDT']}</div>
                </div>
                <div
                    className={`${classPrefix}__chart-header-item-selector
                        ${showProfitPercent ? classPrefix + '__chart-header-item-selector--active' : ''}`}

                    onClick={toggleProfitPercent}
                >
                    <div style={{backgroundColor: colorProfitPercent}}
                         className={`${classPrefix}__chart-header-item-selector-icon ${classPrefix}__chart-header-item-selector-icon--line`}></div>
                    <div
                        className={`${classPrefix}__chart-header-item-selector-name`}>{translate['profitPercent']}</div>
                </div>
                <div
                    className={`${classPrefix}__chart-header-item-selector
                        ${showCountCycles ? classPrefix + '__chart-header-item-selector--active' : ''}`}

                    onClick={toggleCountCycles}
                >
                    <div style={{backgroundColor: colorCountCycles}}
                         className={`${classPrefix}__chart-header-item-selector-icon ${classPrefix}__chart-header-item-selector-icon--line`}></div>
                    <div className={`${classPrefix}__chart-header-item-selector-name`}>{translate['countCycles']}</div>
                </div>
            </div>

            <div className={`${classPrefix}__chart-header-item`}>
                <div className={`${classPrefix}__chart-header-item-radio`}>
                    <div
                        className={`${classPrefix}__chart-header-item-radio-item ${chartMode === 'day' ? classPrefix + '__chart-header-item-radio-item--active' : ''}`}
                        onClick={setDayChartMode}
                    >{translate['profitPerDay']}
                    </div>
                    <div
                        className={`${classPrefix}__chart-header-item-radio-item ${chartMode === 'month' ? classPrefix + '__chart-header-item-radio-item--active' : ''}`}
                        onClick={setMonthChartMode}
                    >{translate['profitPerMonth']}
                    </div>
                </div>
            </div>

            <div className={`${classPrefix}__chart-header-item`}>
                <div
                    className={`${classPrefix}__chart-header-item-selector
                        ${showAmount ? classPrefix + '__chart-header-item-selector--active' : ''}`}

                    onClick={toggleAmount}
                >
                    <div style={{backgroundColor: colorAmount}}
                         className={`${classPrefix}__chart-header-item-selector-icon ${classPrefix}__chart-header-item-selector-icon--chart`}></div>
                    <div className={`${classPrefix}__chart-header-item-selector-name`}>{translate['amountDaily']}</div>
                </div>
            </div>


        </div>
        <div className={`${classPrefix}__chart-item`}>
            <div className={`${classPrefix}__load`}  style={{display:getProfitDone ? 'none' : 'block'}}></div>

            <div className={`${classPrefix}__chart-item-inner`} style={{opacity:getProfitDone ? 1 : 0}}>
                <ComposedChart
                    width={1200}
                    height={500}
                    data={chartData}
                >

                    <CartesianGrid
                        stroke="rgba(49,45,95,.9)"
                    />

                    {/*Daily*/}
                    {amountDailyChart}
                    {profitUSDTDailyChart}
                    {profitPercentDailyChart}
                    {countCyclesDailyChart}
                    {/*{pseudoMaxChart}*/}

                    {/*Monthly*/}
                    {amountMonthlyChart}
                    {profitUSDTMonthlyChart}
                    {profitPercentMonthlyChart}
                    {countCyclesMonthlyChart}

                    <Tooltip
                        contentStyle={{
                            backgroundColor: 'rgba(49,45,95,.9)',
                            border: 'none!important',
                            outlineWidth: 0,
                            padding: 5,
                            paddingBottom: 0
                        }}
                        wrapperStyle={{padding: 0, outlineWidth: 0,}}
                        itemStyle={{padding: 0, paddingBottom: 4, outlineWidth: 0,}}
                        formatter={(value, name) => [value.toFixed(2), translate[name]]}
                        cursor={{stroke: '#fff', strokeWidth: 1}}
                    />

                    <XAxis
                        dataKey="name"
                        tick={{stroke: '#fff'}}
                        stroke={'#fff'}
                        strokeWidth={.5}
                    />
                    <YAxis
                        tick={{stroke: '#fff'}}
                        yAxisId="left"
                        orientation={'left'}
                        dataKey="max"
                        stroke={'#fff'}
                        strokeWidth={.5}
                        padding={{top: 30}}
                    />
                    <YAxis
                        tick={{stroke: '#fff'}}
                        yAxisId="right"
                        dataKey="amountDaily"
                        orientation={'right'}
                        stroke={'#fff'}
                        strokeWidth={.5}
                        padding={{top: 30}}
                    />

                    {dailyBrush}
                    {monthlyBrush}
                </ComposedChart>

            </div>
        </div>
    </div>


}

export default ProfitGraphChart;


const renderDot = (props) => {
    if (props.value === 0) {
        return false
    }

    return <circle
        key={props.key}
        cx={props.cx}
        cy={props.cy}
        r={props.r}
        stroke={props.stroke}
        strokeWidth={props.strokeWidth} fill={props.fill}
    />
}

const renderLabel = (props, color) => {
    const {x, y, stroke, value, width} = props;

    let dx = 0

    if (width) {
        dx = width / 2
    }

    if (value === 0) {
        return false
    }

    return (
        <text x={x} y={y} dy={-8} dx={dx} fill={color} fontSize={12} fontWeight={700} textAnchor="middle">
            {value.toFixed(2)}
        </text>
    );
}